import { useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { useMobileFooterContainer } from '@/app/shell/NavLayout';
import type { IncidentState } from '@/signalr';
import { INCIDENT_PANEL_CSS_CLASS, type IncidentPanel } from './incidentPanel';
import { IncidentDetailMobilePanelSwitch } from './IncidentDetailMobilePanelSwitch';

export type IncidentDetailLayoutBoxProps = {
  chatArea: ReactNode;
  videoPanelArea: ReactNode;
  bannersArea?: ReactNode;
  actionBarArea: ReactNode;
  dataPanelArea: ReactNode;
  mapArea: ReactNode;
  incidentState: IncidentState | null;
  hasActiveEedVideo?: boolean;
  videoExpanded?: boolean;
};

export function IncidentDetailLayoutBox({
  chatArea,
  videoPanelArea,
  bannersArea,
  actionBarArea,
  dataPanelArea,
  mapArea,
  incidentState,
  hasActiveEedVideo = false,
  videoExpanded = false,
}: IncidentDetailLayoutBoxProps) {
  const [activePanel, setActivePanel] = useState<IncidentPanel>('dataPanel');
  const mobileFooterContainer = useMobileFooterContainer();

  const activePanelClass = INCIDENT_PANEL_CSS_CLASS[activePanel];
  const eedVideoClass = hasActiveEedVideo ? 'incident-detail-layout-box--eed-video' : '';
  const videoExpandedClass = videoExpanded ? 'incident-detail-layout-box--video-expanded' : '';

  return (
    <>
      <div className={`incident-detail-layout-box ${activePanelClass} ${eedVideoClass} ${videoExpandedClass}`}>
        <div className="incident-detail-layout-box__data-panel">{dataPanelArea}</div>

        <div className="incident-detail-layout-box__banners">{bannersArea}</div>

        <div className="incident-detail-layout-box__action-bar">{actionBarArea}</div>

        <div className="incident-detail-layout-box__map">{mapArea}</div>

        <div className="incident-detail-layout-box__video-panel">{videoPanelArea}</div>

        <div className="incident-detail-layout-box__chat">{chatArea}</div>
      </div>

      {mobileFooterContainer !== null &&
        createPortal(
          <IncidentDetailMobilePanelSwitch
            activePanel={activePanel}
            onActivePanelChanged={setActivePanel}
            incidentState={incidentState}
          />,
          mobileFooterContainer,
        )}
    </>
  );
}
